import React from "react";
import { useTranslation } from "react-i18next";
import Layout from "../../components/Layout";

const Shipping = () => {
  const { t } = useTranslation("common");

  return (
    <Layout title={t("shipping_policy") || "Shipping Policy"}>
      <div className="max-w-3xl mx-auto bg-white dark:bg-gray-800 p-8 rounded-lg shadow-md">
        <h1 className="text-h1 mb-6 text-gray-900 dark:text-white">
          {t("shipping_policy") || "Shipping Policy"}
        </h1>

        <div className="prose dark:prose-invert max-w-none space-y-6">
          <section>
            <h2 className="text-h3 mb-3">
              {t("shipping_methods") || "Shipping Methods"}
            </h2>
            <p className="text-body text-gray-600 dark:text-gray-400">
              {t("shipping_methods_desc") ||
                "We offer several shipping methods to meet your needs:"}
            </p>
            <ul className="list-disc pl-6 mt-2 space-y-1 text-body text-gray-600 dark:text-gray-400">
              <li>
                {t("standard_shipping") ||
                  "Standard Shipping (3-5 business days)"}
              </li>
              <li>
                {t("express_shipping") ||
                  "Express Shipping (1-2 business days)"}
              </li>
              <li>
                {t("international_shipping") ||
                  "International Shipping (7-14 business days)"}
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-h3 mb-3">
              {t("processing_time") || "Processing Time"}
            </h2>
            <p className="text-body text-gray-600 dark:text-gray-400">
              {t("processing_time_desc") ||
                "Orders are typically processed within 1-2 business days. Orders placed on weekends or holidays will be processed on the next business day."}
            </p>
          </section>

          <section>
            <h2 className="text-h3 mb-3">
              {t("tracking_orders") || "Tracking Your Order"}
            </h2>
            <p className="text-body text-gray-600 dark:text-gray-400">
              {t("tracking_desc") ||
                "Once your order has shipped, you will receive a shipping confirmation email containing your tracking number. You can track your package using the link provided in the email."}
            </p>
          </section>
        </div>
      </div>
    </Layout>
  );
};

export default Shipping;
